import { isEmpty, isEqual } from 'lodash';
import uniq from 'lodash/uniq';
import React from 'react';
import { Button, Label, Table, UncontrolledCollapse } from 'reactstrap';

import { changeRequestShape } from '../../prop-types';
import { getCampaignDiff } from '../utils';

function renderSkuList(skus) {
  return skus && skus.length ? skus.join(', ') : 'N/A';
}

function RefreshSKUComment({ changeRequest }) {
  const diffObject = getCampaignDiff(changeRequest);
  if (!diffObject || isEmpty(diffObject)) {
    return 'This change request does not contain any changes.';
  }

  const { highlightedSkus } = diffObject;
  const productCodes = uniq(
    Object.keys(highlightedSkus.originValue).concat(
      Object.keys(highlightedSkus.draftValue),
    ),
  );

  const changedProducts = productCodes.filter(
    productCode =>
      !isEqual(
        highlightedSkus.originValue[productCode],
        highlightedSkus.draftValue[productCode],
      ),
  );

  return changedProducts.map(productCode => {
    const oldSkus = highlightedSkus.originValue[productCode];
    const newSkus = highlightedSkus.draftValue[productCode];
    const togglerId = `togglerSKUList-${productCode}-${changeRequest.id}`;
    return (
      <div key={productCode} className="my-2">
        <div className="d-flex justify-content-between align-items-center">
          <Label className="m-0 font-weight-semi-bold">{productCode}</Label>
          <Button
            size="sm"
            className="dropdown-toggle btn-outline-light"
            id={togglerId}
          >
            See SKU Lists
          </Button>
        </div>
        <UncontrolledCollapse toggler={`#${togglerId}`}>
          <Table striped>
            <thead>
              <tr>
                <th className="border-top-0">Current</th>
                <th className="border-top-0">New</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id="current-sku">{renderSkuList(oldSkus)}</td>
                <td className="w-50 p-0">{renderSkuList(newSkus)}</td>
              </tr>
            </tbody>
          </Table>
        </UncontrolledCollapse>
      </div>
    );
  });
}

RefreshSKUComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
};

export default RefreshSKUComment;
